import { Action } from 'redux';
import { put } from '@redux-saga/core/effects';

import { ACTION_CREATOR_NAME, errorToBasketErrorModel } from 'helpers';
import { api } from 'repositories/api';
import { PostcodeModel, AddressModel } from 'models';
import { CheckoutActionTypes, CheckoutActions } from 'store/checkout';
import { ErrorAction } from 'store';
import { BasketSagaReturnType } from 'store/sagaHelpers';

export interface FindAddressAction extends Action<CheckoutActionTypes.FIND_ADDRESS> {
    addressSearchEditorId: string;
    postcode: PostcodeModel;
}

export interface FindAddressActionStart extends Action<CheckoutActionTypes.FIND_ADDRESS_START> {
    addressSearchEditorId: string;
}

export interface FindAddressActionSuccess extends Action<CheckoutActionTypes.FIND_ADDRESS_SUCCESS> {
    addressSearchEditorId: string;
    foundAddresses: AddressModel[];
    isSuccessfulSearchButAddressCannotBeParsed: boolean;
}

export interface FindAddressActionError extends ErrorAction<CheckoutActionTypes.FIND_ADDRESS_ERROR> {
    addressSearchEditorId: string;
}

export const findAddress: (addressSearchEditorId: string, postcode: PostcodeModel) => FindAddressAction = (addressSearchEditorId: string, postcode: PostcodeModel) => ({
    type: CheckoutActionTypes.FIND_ADDRESS,
    addressSearchEditorId,
    postcode
});
findAddress[ACTION_CREATOR_NAME] = 'findAddress';

export type FindAddressFunc = (...args: Parameters<typeof findAddress>) => void;

export function* findAddressSaga({ addressSearchEditorId, postcode }: FindAddressAction): BasketSagaReturnType {
    yield put<CheckoutActions>({
        type: CheckoutActionTypes.FIND_ADDRESS_START,
        addressSearchEditorId
    });

    try {
        const addresses: AddressModel[] = yield api.logistics.getAddresses(postcode.code);

        yield put<CheckoutActions>({
            type: CheckoutActionTypes.FIND_ADDRESS_SUCCESS,
            addressSearchEditorId,
            foundAddresses: addresses,
            isSuccessfulSearchButAddressCannotBeParsed: addresses.length === 0
        });

        return true;
    } catch (error) {
        yield put<CheckoutActions>({
            type: CheckoutActionTypes.FIND_ADDRESS_ERROR,
            error: errorToBasketErrorModel(error, 'findAddressSaga'),
            addressSearchEditorId
        });

        return false;
    }
}